export const questions = [
  {
    id: 1,
    question: "Mis kuupäeva peetakse Eesti statistika sünnipäevaks?",
    options: ["10. mai 1937", "20. august 1991", "1. märts 1921"],
    correct: "1. märts 1921",
  },
  {
    id: 2,
    question: "Kus asub Statistikaameti peakontor?",
    options: ["Tallinnas", "Tartus", "Pärnus"],
    correct: "Tallinnas",
  },
  {
    id: 3,
    question: "Mis aastal asutati Statistikaameti eelkäija Riigi Statistika Keskbüroo?",
    options: ["1921", "1922", "1925"],
    correct: "1921",
  },
  {
    id: 4,
    question: "Millise saavutuse eest pälvis Statistikaamet esikoha riigikantselei konkursil „Parim uuendus 2006“?",
    options: ["Veebilehe www.stat.ee avamine", "Kaardirakenduse loomine", "Elektroonilise andmeedastuskanali eSTAT kasutuselevõtmine"],
    correct: "Elektroonilise andmeedastuskanali eSTAT kasutuselevõtmine",
  },
  {
    id: 5,
    question: "Mis aastal tegi Statistikaamet statistika andmebaasi kättesaadavaks tarbijatele?",
    options: ["1999", "2001", "2004"],
    correct: "2001",
  },
  {
    id: 6,
    question: "Millised on Statistikaameti kolm peamist põhiväärtust?",
    options: ["Usaldusväärsus, koostöö ja uuenduslikkus", "Usaldusväärsus, läbipaistvus ja konfidentsiaalsus", "Täpsus, kiirus ja kontroll"],
    correct: "Usaldusväärsus, koostöö ja uuenduslikkus",
  },
  {
    id: 7,
    question: "Millised on Statistikaameti kolm peamist põhimõtet?",
    options: ["Täpsus, kliendikesksus ja kontroll", "Innovatsioon, teenuspõhisus ja kliendikesksus", "Kliendikesksus, teenuspõhisus ja keskkonnasäästlikkus"],
    correct: "Kliendikesksus, teenuspõhisus ja keskkonnasäästlikkus",
  },
  {
    id: 8,
    question: "Millise blogisarjaga alustas Statistikaamet 2023. aastal?",
    options: ["Andmeblogi", "Andmekool", "Andmelabor"],
    correct: "Andmekool",
  },
  {
    id: 9,
    question: "Kellelt sai Statistikaamet 2024. aastal tunnustuse DGINS konverentsi korraldamise eest?",
    options: ["Tartu linnalt", "Euroopa Liidult", "Tallinna linnalt"],
    correct: "Tallinna linnalt",
  },
  {
    id: 10,
    question: "Millal tähistas Statistikaamet Eesti statistika 100. aastapäeva?",
    options: ["2019", "2021", "2022"],
    correct: "2021",
  }
];